import axios from "axios";
import { supabase } from "@/lib/supabase";
import { BACKEND_URL } from "@/lib/env";

const BASE = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: BASE, timeout: 90000 });

client.interceptors.request.use(async (config) => {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    /* no session yet */
  }
  return config;
});

export const api = client;
